(() => {
  const bind = page => {
    if (page.dataset.vmSellingPlanBound) return;
    const form = page.querySelector('form[data-type="add-to-cart-form"]');
    const formId = form && form.getAttribute('id');
    if (!formId) return;
    page.dataset.vmSellingPlanBound = 'true';
    const link = () => page.querySelectorAll('[name="selling_plan"]').forEach(el => {
      if (!el.form) el.setAttribute('form', formId);
    });
    link();
    new MutationObserver(link).observe(page, { childList: true, subtree: true });
  };
  document.querySelectorAll('product-page[data-js-product-component]').forEach(bind);
})();